// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
	border-radius: 20px !important;	
	border:0 !important;
	box-shadow: none !important;
}

.login .profile-img {
	display: block;
	margin: auto;
	margin-bottom: 3rem;
}

.login .p-dialog-titlebar:after {
  content:'';
  position: absolute;
  bottom:-20px;
  left: 50%;
  margin-left: -50px;
  width: 0;
  height: 0;
  border-bottom: solid 50px #ffffff;
  border-left: solid 50px transparent;
  border-right: solid 50px transparent;
}

.login .p-dialog-content {
	border: 0px !important;
	border-radius: 20px !important;

}
.login .p-dialog-titlebar {
	background-color: transparent !important;
	border:0 !important;
}

.login .dialog-sign-in {
	font-size: 40px;
	color: #10497F;
	font-weight: 700;
	margin-top: 3rem;
	margin-bottom: 3rem;
}

.login .p-inputgroup {
	justify-content: center;
  width: 70%;
  margin: auto;
}

.login .p-inputtext:hover {
	border: 1px solid #a6a6a6 !important;
	border-left:0 !important;
}

.login .p-inputtext.p-component {
	width: 100%;
	outline: none;
	background-color: #eaeaea;
}

.login .default-btn {
	margin-top:40px !important;
	margin-bottom:20px !important;
	border-radius: 20px !important;
  padding-left: 60px !important;
  padding-right: 60px !important;
  font-size: 20px !important;
}


.login .default-btn:focus {
	/*box-shadow: none !important;*/
}
.login .default-btn:hover {
	box-shadow: 0 0 0 0.2em #8dcdff !important;
}`, "",{"version":3,"sources":["webpack://./src/views/Login/login.css"],"names":[],"mappings":"AAAA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,mBAAmB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;CACC,sBAAsB;CACtB,8BAA8B;;AAE/B;AACA;CACC,wCAAwC;CACxC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;EACtB,UAAU;EACV,YAAY;AACd;;AAEA;CACC,oCAAoC;CACpC,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;CAC7B,8BAA8B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;AAC5B;;;AAGA;CACC,+BAA+B;AAChC;AACA;CACC,0CAA0C;AAC3C","sourcesContent":[".login {\n\tborder-radius: 20px !important;\t\n\tborder:0 !important;\n\tbox-shadow: none !important;\n}\n\n.login .profile-img {\n\tdisplay: block;\n\tmargin: auto;\n\tmargin-bottom: 3rem;\n}\n\n.login .p-dialog-titlebar:after {\n  content:'';\n  position: absolute;\n  bottom:-20px;\n  left: 50%;\n  margin-left: -50px;\n  width: 0;\n  height: 0;\n  border-bottom: solid 50px #ffffff;\n  border-left: solid 50px transparent;\n  border-right: solid 50px transparent;\n}\n\n.login .p-dialog-content {\n\tborder: 0px !important;\n\tborder-radius: 20px !important;\n\n}\n.login .p-dialog-titlebar {\n\tbackground-color: transparent !important;\n\tborder:0 !important;\n}\n\n.login .dialog-sign-in {\n\tfont-size: 40px;\n\tcolor: #10497F;\n\tfont-weight: 700;\n\tmargin-top: 3rem;\n\tmargin-bottom: 3rem;\n}\n\n.login .p-inputgroup {\n\tjustify-content: center;\n  width: 70%;\n  margin: auto;\n}\n\n.login .p-inputtext:hover {\n\tborder: 1px solid #a6a6a6 !important;\n\tborder-left:0 !important;\n}\n\n.login .p-inputtext.p-component {\n\twidth: 100%;\n\toutline: none;\n\tbackground-color: #eaeaea;\n}\n\n.login .default-btn {\n\tmargin-top:40px !important;\n\tmargin-bottom:20px !important;\n\tborder-radius: 20px !important;\n  padding-left: 60px !important;\n  padding-right: 60px !important;\n  font-size: 20px !important;\n}\n\n\n.login .default-btn:focus {\n\t/*box-shadow: none !important;*/\n}\n.login .default-btn:hover {\n\tbox-shadow: 0 0 0 0.2em #8dcdff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
